import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const CURRENTFLOODZONES_LAYER_ID = 'currentFloodZonesLayer';

const layerConfig = {
  title: 'Current Flood Zones',
};

function CurrentFloodZonesLayer() {
  const dispatch = useDispatch();
  const { currentFloodZonesLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, currentFloodZonesLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (currentFloodZonesLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: CURRENTFLOODZONES_LAYER_ID,

      stroked: false,
      filled: true,
      getFillColor: (d) => {
        if (
          d.properties.Flood_Zone_Designation_Description ===
          '1% Annual Chance Flood Hazard'
        )
          return [207, 28, 144];
        else return [231, 75, 176];
      },
      pointRadiusMinPixels: 3.5,

      pickable: true,
      visible: currentFloodZonesLayer.visible,
      opacity: currentFloodZonesLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: CURRENTFLOODZONES_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Flood Zone Details',
              includeColumns: [
                'Flood_Zone_Designation',
                'Flood_Zone_Designation_Description',
                'Static_Base_Flood_Elevation',
              ],
            }),
          };
        }
      },
    });
  }
}

export default CurrentFloodZonesLayer;
